import {
    ELEMENT_TYPES,
    OVERRIDE_ALL,
    OVERRIDE_DEPENDENCIES,
    OVERRIDE_NO,
    PROJECT_STATUSES,
    REVISION,
    SUBTRACTION_MODES,
    WALL_TYPES
} from '@/constants';

export default {
    'Actions': 'Aktionen',
    'A fresh verification link has been sent to your email address.': 'Ein neuer Verifikationslink wurde verschickt.',
    'Add element to wall': 'Element zu Wand hinzufügen',
    'Add images': 'Neue Bilder hochladen',
    'Addresses': 'Adressen',
    'Administration': 'Administration',
    'Advanced filters': 'Erweiterte Filter',
    'Agency workers': 'Leiharbeiter',
    'All': 'Alle',
    'All Projects': 'Alle Projekte',
    'All Users': 'Alle Benutzer',
    'All rights reserved.': 'Alle Rechte vorbehalten.',
    'All roles': 'Alle Rollen',
    'All types': 'Alle Typen',
    'Always': 'Immer',
    'Amount': 'Anzahl',
    'Architect': 'Architekt',
    'Architect address': 'Architektenadresse',
    'Area': 'Fläche',
    'Are you sure?': 'Sind Sie sicher?',
    'Are you sure to delete this item?': 'Sind Sie sicher das Sie diesen Eintrag löschen wollen?',
    'Are you sure you want to mark this disability as dropped?': 'Sind Sie sicher das Sie diese Behinderung als entfallen markieren wollen?',
    'Are you sure you want to revoke this disability as dropped?': 'Sind Sie sicher das Sie diese Behinderung als entfallen markieren rückgängig machen wollen?',
    'Attachments': 'Anhänge',
    'Attached services': 'Zugeordnete Leistungen',
    'Assign disabilities': 'Behinderungen zuweisen',
    'Auto': 'Automatisch',
    'Available services': 'Verfügbare Leistungen',
    'Client address': 'Auftraggeberadresse',
    'Back': 'Zurück',
    'Background': 'Untergrund',
    'Before proceeding, please check your email for a verification link.': 'Best\u00e4tigen Sie bitte zuerst Ihre E-Mail.',
    'Break length' : 'Pausenlänge',
    'Building type': 'Gebäude',
    'City': 'Stadt',
    'Characteristics': 'Kennzeichen',
    'Clear': 'Zur\u00fccksetzen',
    'Clone elements': 'Raumelement duplizieren',
    'Clone foundations': 'Untergrunde duplizieren',
    'Close': 'Schlissen',
    'Closed': 'Geschlossen',
    'Complete services': 'Leistungen als erledigt markieren',
    'Completed steps': 'Erledigte Schritte',
    'Company': 'Unternehmen',
    'Component': 'Bauteil',
    'Components': 'Bauteile',
    'Confirm Password': 'Passwort best\u00e4tigen',
    'Contract start': 'Vertragsbeginn',
    'Contract end': 'Vertragsende',
    'Count': 'Anzahl',
    'Country': 'Land',
    'Covered': 'Verdeckt',
    'Create': 'Erstellen',
    'Create new address': 'Neue Adresse',
    'Create new component': 'Neues Bauteil',
    'Create new customer': 'Neuer Kunden',
    'Create new disability': 'Neue Behinderung',
    'Create new element': 'Neues Raumelement',
    'Create new foundation': 'Neuer Untergrund',
    'Create new floor': 'Neue Etage',
    'Create new line': 'Neue Zeile',
    'Create new project': 'Neues Projekt',
    'Create new room': 'Neuer Raum',
    'Create new wall': 'Neue Wand',
    'Create new ceiling': 'Neue Decke',
    'Create new ground': 'Neuer Boden',
    'Create new pier': 'Neue Stütze',
    'Create new round pier': 'Neue Runde Stütze',
    'Create new trapezoid': 'Neue Trapez',
    'Created': 'Erstellt',
    'Created at': 'Erstellt am',
    'Created by': 'Erstellt durch',
    'Created at: :date': 'Erstellt am: {date}',
    'Deleted at: :date': 'Gelöscht am: {date}',
    'Deleted by: :user': 'Gelöscht durch: {user}',
    'Current month': 'Aktueller Monat',
    'Customer': 'Kunde',
    'Customers': 'Kunden',
    'Construction manager': 'Bauleiter',
    'Construction report': 'Bautagesberichte',
    'Copies': 'Kopien',
    'Copy services': 'Leistungen kopieren',
    'Date': 'Datum',
    'Delete': 'L\u00f6schen',
    'Delete {0}': '{0} l\u00f6schen',
    'Restore {0}': '{0} wiederherstellen',
    'Force delete': 'Endgültig löschen',
    'Description': 'Beschreibung',
    'Depth': 'Tiefe',
    'Diameter': 'Durchmesser',
    'Disabilities': 'Behinderungen',
    'Disability': 'Behinderung',
    'Default' : ' (Standard)',
    'Document management': 'Dokumentenverwaltung',
    'Download': 'Herunterladen',
    'Never': 'Nie',
    'No date selected': 'Kein Datum ausgewählt',
    'No subtraction': 'Kein Abzug',
    'No time selected': 'Keine Uhrzeit ausgewählt',
    'Drop disabilities': 'Behinderungen als entfallen markieren',
    'Dropped': 'Entfallen',
    'Dropped at': 'Entfallen am: {0}',
    'Duplicate': 'Duplizieren',
    'Duplicate Mirror help': 'Beim gespiegelten duplizieren werden alle Räume sowie gegebenfalls alle Bausteine eines Raumes in umgekehrter Reihenfolge dupliziert.',
    'Duplicate as Mirror': 'Spiegelnd duplizieren',
    'Duplicated': 'Erfolgreich dupliziert',
    'Duplicate to other location': 'Ist anderes Verzeichnis duplizieren',
    'Duplicate with dependencies': 'Mit Abhängigkeiten duplizieren',
    'Duplicate with services': 'Mit Leistungen duplizieren',
    'Duplicate with elements': 'Mit Raumelementen duplizieren',
    'Duplicate room to floor or components': 'Raum an eine andere Etage oder Baukomponente duplizieren.',
    'Duplicate wall to room or floor': 'Wand in eine andere Etage oder Raum duplizieren.',
    'Duplicate floor to components': 'Etage in eine andere Baukomponente duplizieren.',
    'Duration': 'Dauer',
    'E-Mail Address': 'E-Mail Adresse',
    'Edit': 'Bearbeiten',
    'Edit {0}': '{0} bearbeiten',
    'Element': 'Raumelement',
    'Elements': 'Raumelemente',
    'Error': 'Fehler',
    'Explanation': 'Erläuterung',
    'Export': 'Exportieren',
    'Export as Excel': 'Als Excel exportieren',
    'Factor': 'Faktor',
    'File': 'Datei',
    'Filter by role': 'Nach Role filtern',
    'Filter by user': 'Nach Benutzer filtern',
    'First name': 'Vorname',
    'Floor': 'Etage',
    'Floors': 'Etagen',
    'Floor space': 'Grundfläche',
    'Forbidden': 'Unzul\u00e4ssig',
    'Foreman': 'Polier',
    'Forgot Your Password?': 'Passwort vergessen?',
    'Formula': 'Formel',
    'Formula number': 'Formelnummer',
    'Foundation': 'Untergrund',
    'Foundation services': 'Untergrund Leistungen',
    'Foundations': 'Untergründe',
    'from': 'von',
    'General': 'Allgemein',
    'Leave empty to apply floor height': 'Bitte leer lasen um Etagenhöhe anzuwenden',
    'Location': 'Ortsbezeichnung',
    'Go Home': 'Nach Hause',
    'Groups': 'Benutzergruppen',
    'Height': 'Höhe',
    'Hello!': 'Hallo!',
    'Help': 'Hilfe',
    'How to handle duplication errors': 'Bei bereit existierendem Eintrag',
    'If you did not create an account, no further action is required.': 'Wenn Sie keinen Account beantragt haben ist keine weitere Handlung n\u00f6tig.',
    'If you did not receive the email': 'Wenn Sie keine E-Mail erhalten haben',
    'If you did not request a password reset, no further action is required.': 'Wenn Sie keine Zur\u00fccksetzung des Passworts beantragt haben ist keine weitere Handlung n\u00f6tig.',
    'If you\u2019re having trouble clicking the ":actionText" button, copy and paste the URL below\ninto your web browser: [:actionURL](:actionURL)': 'Wenn Sie Schwierigkeiten haben, den ":actionText" Button zu dr\u00fccken, f\u00fcgen sie bitte folgende Adresse in Ihren Browser ein: [:actionURL](:actionURL)',
    'image': 'Bild',
    'Image': 'Bild',
    'Images': 'Bilder',
    'Import': 'Importieren',
    'Import services': 'Leistungen importieren',
    'Internet search': 'Internet-Suche',
    'Is small area': 'Kleinflächen',
    'Issues': 'Probleme',
    'Issue subject': 'Link zum Problem',
    'Issue marked as resolved': 'Problem als geklärt markiert',
    'Item not found': 'Eintrag nicht gefunden',
    'Label': 'Bezeichnung',
    'Last name': 'Nachname',
    'Last update': 'Zuletzt aktualisiert',
    'Last update: :date': 'Zuletzt aktualisiert: {date}',
    'Last message by: :user': 'Letzte Nachricht: {user}',
    'Latitude': 'Breitengrad',
    'Long version as PDF': 'Langversion als PDF',
    'Longitude': 'Längengrad',
    'Length': 'Länge',
    'Loading application': 'Applikation wird geladen',
    'Lock project': 'Zur bearbeitung sperren',
    'Login': 'Anmelden',
    'Logout': 'Abmelden',
    'Logs': 'Logbuch',
    'Long edge': 'Lange Seite',
    'Breaks': 'Pausen',
    'Break: {0} min': 'Pause: {0} min',
    "Max temp": 'Max Temp',
    'Min temp': 'Min Temp',
    'Mark completed': 'Als erledigt markieren',
    'Mark as dropped': 'Als entfallen markieren',
    'Mark as resolved': 'Als geklärt markieren',
    'Revoke mark as dropped': 'Als entfallen markieren Rückgangig machen',
    'confirm': 'Sind Sie sich sicher ?',
    'Measurement': 'Aufmaß',
    'Name': 'Name',
    'Network error': 'Netzwerkfehler',
    'New Project': 'Projekt erstellen',
    'New Element': 'Neues Raumelement',
    'New Foundation': 'Neuer Untergrund',
    'New issue': 'Neues Problem',
    'New User': 'Benutzer erstellen',
    'New Wall': 'Neue Wand',
    'New room construction': 'Neuen Baustein erstellen',
    'Next month': 'Nächster Monat',
    'Next year': 'Nächstes Jahr',
    'No': 'Nein',
    'No foundation selected': 'Kein Untergrund ausgewählt',
    'No results found': 'Keine Ergebnisse gefunden',
    'No value': 'Nicht vergeben',
    'Notice': 'Anmerkungen',
    'Oh no': 'Oh nein',
    'Object': 'Objektadresse',
    'Open': 'Offen',
    'Ordinal': 'Ordnungszahl',
    'Ordinal mask': 'Ordnungszahl Maske',
    'Organization': 'Unternehmen',
    'Overview': 'Übersicht',
    'Page Expired': 'Seite abgelaufen',
    'Page Not Found': 'Seite konnte nicht gefunden werden',
    'Password': 'Passwort',
    'Phone number': 'Telefonnummer',
    'pieces': 'Stck',
    'Place': 'Ort',
    'Planning': 'Planung',
    'Please check your inputs': 'Bitte überprüfen Sie Ihre eingaben',
    'Please click the button below to verify your email address.': 'Bitte klicken Sie den Button, um Ihre E-Mail Adresse zu best\u00e4tigen.',
    'Please select': 'Bitte auswählen',
    'Please select the type': 'Bitte erst den Typ auswählen',
    'Please try again later': 'Bitter versuchen Sie es erneuert',
    'Postal code': 'Postleitzahl',
    'Previous month': 'Vorheriger Monat',
    'Previous year': 'Vorheriges Jahr',
    'Progress': 'Fortschritt',
    'Project': 'Projekt',
    'Projects': 'Projekte',
    'Project manager': 'Abrechner',
    'Project management': 'PM',
    'Project name': 'Projektname',
    'Project number': 'Projektnummer',
    'Project {0} overview': '{0} Übersicht',
    'Properties': 'Eigenschaften',
    'Regards': 'Mit freundlichen Gr\u00fc\u00dfen',
    'Register': 'Registrieren',
    'Remember Me': 'Angemeldet bleiben',
    'Reset': 'Zur\u00fccksetzen',
    'Reset filters': 'Filter zur\u00fccksetzen',
    'Reset Password': 'Passwort zur\u00fccksetzen',
    'Reset Password Notification': 'Passwort zur\u00fccksetzen Notifikation',
    'Resolved': 'Geklärt',
    'Restore': 'Wiederherstellen',
    'Revision history': 'Revisionen',
    'Quantity': 'Menge',
    'Role': 'Rolle',
    'Room': 'Raum',
    'Rooms': 'Räume',
    'Room constructions': 'Bausteine',
    'Save': 'Speichern',
    'Save and new': 'Speichern und Weiter anlegen',
    'Saved': 'Gespeichert',
    'Search': 'Suchen',
    'Select all': 'Alles auswählen',
    'Select all in {0}': 'Alles in {0} auswählen',
    'Select all with the same name': 'Alle mit dem gleichen Namen auswählen',
    'Selected :count items': 'Es wurde nichts ausgewählt | 1 Element ausgewählt | {count} Elemente ausgewählt',
    'Send Password Reset Link': 'Link zum Zur\u00fccksetzen des Passworts senden',
    'Services': 'Leistungen',
    'Services imported': 'Leistungen wurden importiert',
    'Services to complete': 'Leistungen zu erledigen',
    'Service': 'Leistung',
    'Service Unavailable': 'Service nicht verf\u00fcgbar',
    'Short edge': 'Kurze Seite',
    'Short name': 'Abkürzung',
    'Short version': 'Kurzversion',
    'Short version as PDF': 'Kurzversion als PDF',
    'Short version as RTF': 'Kurzversion als RTF',
    'Show all': 'Alles anzeigen',
    'Show deleted': 'Gelöschte Einträge anzeigen',
    'Show images': 'Bilder anzeigen',
    'Show revision history': 'Revisionen anzeigen',
    'Soffit': 'Laibung',
    'Sorry, the page you are looking for could not be found.': 'Tut uns Leid, die Seite konnte nicht gefunden werden.',
    'Sorry, we are doing some maintenance. Please check back soon.': 'Tut uns Leid, wir arbeiten gerade an unserer Webseite. Bitte versuchen Sie es sp\u00e4ter erneut.',
    'Sorry, you are forbidden from accessing this page.': 'Tut uns Leid, Sie haben keine Rechte, diese Seite zu besuchen.',
    'Sorry, you are making too many requests to our servers.': 'Tut uns Leid, Sie machen derzeit zu viele Anfragen an unseren Server.',
    'Sorry, you are not authorized to access this page.': 'Tut uns Leid, Sie haben keine Rechte, diese Seite zu besuchen.',
    'Sorry, your session has expired. Please refresh and try again.': 'Tut uns Leid, Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite neu und probieren Sie es erneut.',
    'Staff member': 'Mitarbeiter',
    'Staff members': 'Mitarbeiter',
    'Status': 'Status',
    'Steps': 'Arbeitsschritte',
    'Street': 'Straße',
    'Subcontractors': 'Subunternehmer',
    'Submit': 'Versenden',
    'Subtract': 'Abziehen',
    'Subtraction mode': 'Abziehen',
    'Success': 'Erfolgreich',
    'Tags': 'Tags',
    'This project is locked by: {0}': 'Dieses Project wurde durch {0} zur Bearbeitung gesperrt',
    'Title': 'Titel',
    'The requested item could not be found': 'Der gewünschte Eintrag konnte nicht gefunden werden',
    'to': 'bis',
    'Today': 'Heute',
    'To create a new element use the plus button': 'Um ein neues Raumelement anzulegen, benutzen Sie den "+" Knopf',
    'To create a new components use the plus button': 'Um ein neues Bauteil anzulegen, benutzen Sie den "+" Knopf',
    'To create a new floor use the plus button': 'Um eine neue Etage anzulegen, benutzen Sie den "+" Knopf',
    'To create a new foundation use the plus button': 'Un einen neuen Untergrund zu erstellen, benutzen Sie den "+" Knopf',
    'To create a new room use the plus button': 'Um eine neuen Raum anzulegen, benutzen Sie den "+" Knopf',
    'To create a new wall use the plus button': 'Um eine neuen Wand anzulegen, benutzen Sie den "+" Knopf',
    'Toggle navigation': 'Navigation umschalten',
    'Too Many Requests': 'Zu viele Anfragen',
    'Trapezoid leg 1': 'Schenkel 1',
    'Trapezoid leg 2': 'Schenkel 2',
    'Type': 'Typ',
    'Type to search': 'Geben Sie ein Suchbegriff ein',
    'Unauthorized': 'Nicht autorisiert',
    'Unclear': 'Unklar',
    'Unhandled relations': 'Unbehandelte Beziehungen',
    'Unit': 'Einheit',
    'Unlock project': 'Sperre entfernen',
    'Upload attachment': 'Anhang hohladen',
    'Update': 'Aktualisieren',
    'Update walls height': 'Wändehöhe überschreiben',
    'Use cursor keys to navigate calendar dates': 'Verwenden Sie die Cursor-Tasten zum Navigieren in  Kalenderdaten',
    'Users': 'Benutzer',
    'Users involved': 'Beteiligte Benutzer',
    'User group': 'Benutzergruppe',
    'Value correction': 'Wertekorrektur',
    'Validation error': 'Ungültige Daten',
    'Verify Email Address': 'E-Mail Adresse best\u00e4tigen',
    'Verify Your Email Address': 'Best\u00e4tigen Sie Ihre E-Mail Adresse',
    'Wall services': 'Wand spezifische Leistungen',
    'Wall element services': 'Element spezifische Leistungen',
    'Walls': 'W\u00e4nde',
    'Weather': 'Wetter',
    'Welcome {0}': 'Hallo {0}',
    'Width': 'Breite',
    'Width: {0} m': '{0} m Breite',
    'Wind speed': 'Windstärke',
    'Whoops!': 'Ups!',
    'Whoops, something went wrong on our servers.': 'Ups, etwas ist schief gelaufen.',
    'Yes': 'Ja',
    'You are now logged in': 'Sie haben sich erfolgreich eingeloggt',
    'You are receiving this email because we received a password reset request for your account.': 'Sie erhalten diese E-Mail, weil wir einen Antrag auf eine Zur\u00fccksetzung Ihres Passworts bekommen haben.',
    'Your message': 'Deine Nachricht',
    'click here to request another': 'klicken Sie hier, um eine neue anzufordern.',
    'hi': 'hallo',
    'building_type_placeholder': 'Einfamilienhaus, Büro, etc.',
    'item_created': '<strong>{user}<\/strong> hat {model} erstellt',
    'item_revision': '<i>{user}<\/i> hat <strong>{field}<\/strong> vom <b><i>{model}</i></b> von <strong>{oldValue}<\/strong> auf <strong>{newValue}<\/strong> ge\u00e4ndert',
    'pagination': {
        'next': 'Weiter &raquo;',
        'perPage': 'pro Seite',
        'previous': '&laquo; Zur\u00fcck',
    },
    'admin': 'Administrator',
    'user': 'Benutzer',
    'foreman': 'Polier, Vorarbeiter',
    'construction_manager': 'Bauleiter',

    'staff_member': 'Mitarbeiter',
    'agency_worker': 'Leiharbeiter',
    'subcontractor': 'Subunternehmer',

    'disability_painters': 'Behinderungen (Maler)',
    'disability_eifs': 'Behinderungen (WDVS)',
    'concern_painters': 'Bedenken (Maler)',
    'concern_eifs': 'Bedenken (WDVS)',

    'e.g. Wall 1 ...': 'z.B. Wand 1 ...',

    [ELEMENT_TYPES.TYPE_DOOR]: 'Tür',
    [ELEMENT_TYPES.TYPE_WINDOW]: 'Fenster',
    [ELEMENT_TYPES.TYPE_BEAM]: 'Unterzug',
    [ELEMENT_TYPES.TYPE_JUT]: 'Vorsprung',
    [ELEMENT_TYPES.TYPE_PLINTH]: 'Sockel',
    [ELEMENT_TYPES.TYPE_WALL_CHEST]: 'Wandverkofferung',
    [ELEMENT_TYPES.TYPE_WALL_RECESS]: 'Wandnische',
    [ELEMENT_TYPES.TYPE_PIER]: 'Stütze',
    [ELEMENT_TYPES.TYPE_ROUND_PIER]: 'Rundstütze',
    [ELEMENT_TYPES.TYPE_MOULDING]: 'Deckenfries',
    [ELEMENT_TYPES.TYPE_WINDOW_SILL]: 'Fensterbank',
    [ELEMENT_TYPES.TYPE_SOFFIT]: 'Laibung',
    [ELEMENT_TYPES.TYPE_CORNER_CASE]: 'Eckkoffer',
    [ELEMENT_TYPES.TYPE_WALL_CENTER_CASE]: 'Wand-Mittelkoffer',
    [ELEMENT_TYPES.TYPE_BEAM_CEILING_CASE]: 'Unterzug/Deckenkoffer',
    [ELEMENT_TYPES.TYPE_CENTER_BEAM_CEILING_CASE]: 'Mittel-Unterzüge/Deckenkoffer',
    [ELEMENT_TYPES.TYPE_TUBE]: 'Rohr',
    [ELEMENT_TYPES.TYPE_FRAME]: 'Zarge',
    [ELEMENT_TYPES.TYPE_FRAME]: 'Zarge',

    [WALL_TYPES.WALL]: 'Wand',
    [WALL_TYPES.ROUND_PIER]: 'Rundstütze',
    [WALL_TYPES.PIER]: 'Stütze',
    [WALL_TYPES.CEILING]: 'Decke',
    [WALL_TYPES.GROUND]: 'Boden',
    [WALL_TYPES.TRAPEZOID]: 'Trapez',

    [REVISION.START_OF_DAY]: 'Tagesstart',
    [REVISION.END_OF_DAY]: 'Tagesende',

    [OVERRIDE_NO]: 'Abbrechen',
    [OVERRIDE_ALL]: 'Alles überschreiben (Maße werden überschrieben)',
    [OVERRIDE_DEPENDENCIES]: 'Nur Abhängigkeiten überschreiben (Maße werden behalten)',

    [PROJECT_STATUSES.CREATED]: 'Projekt angelegt',
    [PROJECT_STATUSES.MEASUREMENT]: 'Rohmassen eingetragen',
    [PROJECT_STATUSES.MEASUREMENT_COMPLETED]: 'Aufmaß komplett erstellt',
    [PROJECT_STATUSES.MEASUREMENT_REALIZATION]: 'Ausführung',
    [PROJECT_STATUSES.ARCHIVED]: 'Archiv',

    'subtraction_modes': {
        [SUBTRACTION_MODES.AUTO]: 'Automatisch',
        [SUBTRACTION_MODES.ALWAYS]: 'Immer',
        [SUBTRACTION_MODES.NEVER]: 'Niemals',
        'override':{
            [SUBTRACTION_MODES.AUTO]: 'Automatisch',
            [SUBTRACTION_MODES.ALWAYS]: 'Ja',
            [SUBTRACTION_MODES.NEVER]: 'Nein',
        }
    },

    'attributes' : {
        'name': 'Name',
        'username': 'Benutzername',
        'email': 'E-Mail-Adresse',
        'salutation': 'Anrede',
        'first_name': 'Vorname',
        'last_name': 'Nachname',
        'password': 'Passwort',
        'password_confirmation': 'Passwort-Bestätigung',
        'city': 'Stadt',
        'country': 'Land',
        'address': 'Adresse',
        'phone': 'Telefonnummer',
        'mobile': 'Handynummer',
        'age': 'Alter',
        'sex': 'Geschlecht',
        'gender': 'Geschlecht',
        'day': 'Tag',
        'month': 'Monat',
        'year': 'Jahr',
        'hour': 'Stunde',
        'minute': 'Minute',
        'second': 'Sekunde',
        'title': 'Titel',
        'content': 'Inhalt',
        'description': 'Beschreibung',
        'excerpt': 'Auszug',
        'date': 'Datum',
        'time': 'Uhrzeit',
        'available': 'verfügbar',
        'size': 'Größe',
        'company': 'Unternehmen',
        'road': 'Straße',
        'house_number': 'Hausnummer',
        'postcode': 'Postleitzahl',
        'latitude': 'Breitengrad',
        'longitude': 'Längengrad',
        'website': 'Webseite',
        'code': 'Code',
        'value': 'Wert',
        'role': 'Benutzerrole',
        'text': 'Text',
        'price': 'Preis',
        'is_active': 'Aktiv',
        'agb': 'Datenschutzerklärung',
        'abbreviation': 'Abkürzung',
        'file': 'Ausgewählte Datei',
        'source': 'Quelle',
        'additional_information': 'Zusätzliche Informationen',
        'roles': 'Rolen',
        'terms': 'Bedingungen',
        'subject': 'Betreff',
        'body': 'Nachricht',

        'place': 'Ort',
        'room': 'Raum',
        'element': 'Element',
        'background': 'Untergrund',
        'factor': 'Faktor',
        'formula': 'Formel',
        'customer_id': 'Kunde',
        'building_type': 'Gebäude',
        'soffit': 'Laibung',
        'width': 'Breite',
        'height': 'Höhe',
        'type': 'Typ',
        'label': 'Bezeichnung',
        'quantity': 'Menge',
        'address_id': 'Objektadresse',
        'ordinal_mask': 'Ordnungszahl Maske'
    },
    'disability_statuses':{
        'all': 'alle',
        'closed': 'geschlossene',
        'open': 'offene'
    },
    'restore image':'Bild wiederherstellen',
    'confirm restoring image': 'Bild wiederherstellen bestätigen',
    'cancel':'Abbruch',
    'image force delete': 'Bild endgültig löschen',
    'image force delete confirm':'Endgültiges Löschen bestätigen',
    'image delete': 'Bild löschen',
    'image delete confirm': 'Bild löschen bestätigen',
    "DA11 Export type": "DA11 Export Type",
    "DA11 Export": "DA11 Export",
    "DA11 Export by Service": "Leistungsgruppiert",
    "DA11 Export by Project": "Projektstruktur",
    "DA11 Export scope": "Export bereich",
    "DA11 Export complete": "Gesamtes Aufmaß",
    "DA11 Export only completed": "Abgearbeitete Leistungen",
    "DA11 Export date": "Abgearbeitet nach",
    "file_to_large":"{fileName} darf maximal {size} groß sein!",
    "file_to_large_aggregate": "Die Summe der größe aller Dateien darf maximal {size} sein!",
    "max_file_amount":"Maximal {amount} Dateien sind erlaubt gleichzeitig hochzulanden!",
    "Covered Area":"Bedeckte Fläche",
    "needs recalculation": "Muss neu berechnet werden. (Speichern)"
};
